import { render } from "./SubtitlesIOS.vue?vue&type=template&id=c631c2ac&scoped=true"
import script from "./SubtitlesIOS.vue?vue&type=script&lang=js"
export * from "./SubtitlesIOS.vue?vue&type=script&lang=js"

import "./SubtitlesIOS.vue?vue&type=style&index=0&id=c631c2ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c631c2ac"

export default script